// extracted by mini-css-extract-plugin
module.exports = {"events":"Events-module__events___2tJBR","event":"Events-module__event___3837a"};